<template>
  <v-row no-gutters>
    <v-col cols="12" class="mirror-navigation">
      <v-btn
        :disabled="disableButton('previous')"
        text
        elevation="0"
        @click="handlerPagination('previous')"
      >
        Anterior
      </v-btn>
      <span class="mirror-navigation-title">
        Retrancas
      </span>
      <v-btn
        :disabled="disableButton('next')"
        text
        elevation="0"
        @click="handlerPagination('next')"
      >
        Próxima
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import mirrorNavigation from '@/mixins/mirrorNavigation.js';
export default {
  name: 'MirrorNavigation',
  mixins: [mirrorNavigation],
  props: {
    slug: {
      type: Object,
      required: true,
    },
    mirror: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filteredMirror() {
      return this.mirror;
    },
  },
  methods: {
    disableButton(value) {
      return value === 'next' ? !this.nextMirror : !this.previousMirror;
    },

    changeSelectedMirrorItem(type) {
      this.$emit(
        'changeSelectedMirrorItem',
        this.getNextOrPreviousMirrorId(type),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';
@import '@/assets/scss/theme-v2.scss';

.mirror-navigation {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 64px;
  background-color: $color-white;
  border-radius: 5px;

  @include for-size(desktop-up) {
    height: 40px;
  }

  .mirror-navigation-title {
    font-family: 'globotipo' !important;
    font-weight: 700 !important;
    font-size: 1em !important;
    text-transform: uppercase;
    color: $color-primary-light;
  }
}
</style>
